import { StationLogo } from "../components/StationLogo";
import { useStations } from "../api";
import { longDate, plural } from "../format";
import { useTitle } from "../hooks";

export function About() {
  useTitle("O projekcie");
  const { data } = useStations();
  return (
    <article className="prose">
      <h1>O projekcie</h1>
      <p>
        Poplista zbiera publiczne notowania polskich radiowych list przebojów w
        jednym miejscu, żeby dało się je przeszukać, porównać i odkryć w nich
        dawno zapomniane piosenki.
      </p>

      <h2>Źródła</h2>
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Lista</th>
              <th>Notowań</th>
              <th>Od</th>
              <th>Do</th>
              <th>Częstotliwość</th>
            </tr>
          </thead>
          <tbody>
            {data?.stations.flatMap((s) =>
              s.charts.map((c) => (
                <tr key={c.slug}>
                  <td>
                    <span className="about-station">
                      <StationLogo slug={s.slug} size={26} />
                      <strong>{s.name}</strong>
                    </span>{" "}
                    {c.sourceUrl ? (
                      <a
                        href={c.sourceUrl}
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        {c.name}
                      </a>
                    ) : (
                      c.name
                    )}
                  </td>
                  <td>
                    {c.editions.toLocaleString("pl-PL")}{" "}
                    {plural(c.editions, "notowanie", "notowania", "notowań")}
                  </td>
                  <td>{c.firstDate ? longDate(c.firstDate) : ""}</td>
                  <td>{c.lastDate ? longDate(c.lastDate) : ""}</td>
                  <td>
                    {{
                      daily: "codzienna",
                      weekly: "tygodniowa",
                      snapshot: "migawki",
                      irregular: "nieregularna",
                    }[c.cadence] ?? c.cadence}
                  </td>
                </tr>
              )),
            )}
          </tbody>
        </table>
      </div>
    </article>
  );
}
